import { VoiceStatus } from "@next-platform/packages-ts-types";
import { ListItemBadgeVariant } from "@next-platform/client-common-spicy-ui";

const getVoiceStatus = function (voiceStatus: VoiceStatus) {
  const processingStatuses = [VoiceStatus.READY_FOR_PROCESSING, VoiceStatus.PROCESSING, VoiceStatus.PENDING_UPLOAD];
  if (processingStatuses.includes(voiceStatus)) return ListItemBadgeVariant.GENERATING;
  if (voiceStatus === VoiceStatus.READY_FOR_PREVIEW) return ListItemBadgeVariant.PREVIEW;
  if (voiceStatus === VoiceStatus.FAILED) return ListItemBadgeVariant.ERROR;
  return undefined;
};

export default getVoiceStatus;
